module.exports = __webpack_public_path__ + "img/Brutto_Grupa_4.6f07aaa0.png";